import { ActionTypes } from '../constants/index';

export const getTransactionInfo = (payload: any) => ({
  type: ActionTypes.TRANSACTION_DETAILS_LIST_REQUEST,
  payload,
});
